<nav class="navbar navbar-light bg-light">


  <!-- Para dispositivos >= medium device -->

  <div class="container d-none d-md-block" style="margin-bottom: 18px;">
    <div class="row p-0 text-left d-flex" style="width: 100%;">
      <div class="col-lg-12">
        <span class="navbar-brand title-contact text-left">CONTACTO</span>
      </div>
    </div>
    <div class="row p-20" style="width: 100%;">
      <div class="col-12">
        <hr class="style0">
      </div>
    </div>
    <div class="row p-20" style="margin-top: 40px; height: 400px; background: url(&quot;https://promocionesbancoppel.com/bcp/fondo_contacto.png&quot;) 0% 0% / 100% 100% no-repeat;">
      <div class="col-6 justify-content">
        <span class="contact-font"><br>Si tienes alguna duda, necesitas informaci&oacute;n adicional o quieres reportar que alg&uacute;n establecimiento no reconoci&oacute;
          la promoci&oacute;n env&iacute;a un correo a: <span class="mail-contact-font">promobancoppel@maxvalue.com.mx</span>
        </span>
      </div>
    </div>
  </div>

  <!-- Para dispositivos < medium device -->

  <div class="container d-block d-md-none" style="margin-bottom: 18px;">
    <div class="row p-0 text-left d-flex" style="width: 100%;">
      <div class="col-lg-12">
        <span class="navbar-brand title-contact text-left">CONTACTO</span>
      </div>
    </div>
    <div class="row p-2" style="width: 100%;">
      <div class="col-12">
        <hr class="style0">
      </div>
    </div>
    <div class="row p-0" >
      <div class="col-12 justify-content">
        <span class="contact-font-mobile"><br>Si tienes alguna duda, necesitas informaci&oacute;n adicional o quieres reportar que alg&uacute;n establecimiento no reconoci&oacute;</span>
      </div>
    </div>
    <div class="row p-0" style="margin-top: 0px; height: 400px; background: url(&quot;https://promocionesbancoppel.com/bcp/fondo_contacto_movil.png&quot;) 0% 0% / 100% 100% no-repeat;">
      <div class="col-12 justify-content">
        <span class="contact-font-mobile">
          la promoci&oacute;n env&iacute;a un correo a: <span class="mail-contact-font-mobile">promobancoppel@maxvalue.com.mx</span>
        </span>
      </div>
    </div>
  </div>



<!--   <div class="container d-none d-lg-block" style="margin-bottom: 18px;">
    <div class="row p-2">
      <div class="col-lg-12">
        <span class="navbar-brand title-footer">Contáctanos</span>
      </div>
    </div>
  </div>
 -->

</nav>
